import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
import { FilterDrama } from "@mui/icons-material";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";




const ProfileActivityTable = ({ ...props}) => {
  // Date format: mm/dd/yyyy hh: mm
  const loginInfo = useSelector(state => state.loginInfo);

  let location = useLocation();
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
  

    const [sortColumn, setSortColumn] = useState({
        sortField: "reportYear",
        sortDirection: "desc"
    });

    const [filter, setFilter] = useState(null);
    const [docFilter, setDocFilter] = useState(null);
  
useEffect(()=>{
    var passedData = location.state;
    
    if(isInObject("filter",passedData)) {
        //console.log("setFilter");
        //console.log(passedData.filter);
        setFilter(passedData.filter);
    }
    else {
        setFilter({
            startIndex:0,
            entryPerPage:10,
            sortingColumn:sortColumn.sortField,
            sortingOrder:sortColumn.sortDirection,
            searchTerm:""
        });
    }
    //console.log(filter);
    //console.log(docFilter);
},[])



    const getTest = async (filter) => {   
        var call = {
            paginationRequest: filter
        };
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/profile/managePsoProfile';
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }


    const getDocumentDownloadCall = async (docId) => {   
        //console.log(docId);
        var url = '/api/dlms/retrieveDocument';

        return httpDownload.post(url, {"docId": docId},{ 
            responseType: 'blob',
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const handleFileDownload = async (docId, fileName) => {
        const res = await getDocumentDownloadCall(docId);
        
        if (res) {
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
                //console.log(filename)
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        }
    }


    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        const title = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return "Click the link to edit user " + rowName + ".";
        }

        const orgNameTitle = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return rowName.psoName;
        }

        const fullNameTitle = function ({rowName}) {
            //console.log(rowName);
            return "Click the link to view user " + rowName + ".";
        }

        const userState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const updateState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                docId: rowName.docId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const profileState = function ({rowName}) {
   
            return {
                state: {
                    profileId: rowName.id, 
                    orgId: rowName.orgId,
                    psoppcAdmin: false
                },
                backRedirect: {
                    path: location.pathname,
                    state: location.state
                }
            };
        }
        
        const getProfileViewUrl = function ({row}) {
            var path = '/manage/viewPSOProfile';
            return path;
        }

        listColumns.push(Datatable_Column({
            name:"Reporting Year", 
            columnName:"reportYear", 
            selectedRows: selectedList, 
            sortable:true, 
            isLink: true, 
            linkData:{
                title: null, 
                pathname: getProfileViewUrl,
                text: null, 
                state:profileState
            },
            //sortFieldNum:4, 
            /*isLink: false, */
            //delimiter: "-",
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Profile Status", 
            columnName:"statusName", 
            selectedRows: selectedList, 
            sortable:true, 
            //sortFieldNum:4,
            sortingInfo:sortingInfo
        }))
       
        listColumns.push(Datatable_Column({
            name:"Profile Added Date", 
            columnName:"addedDate", 
            selectedRows: selectedList, 
            sortable:true, 
            sortFieldNum:4, 
            sortingInfo:sortingInfo,
            formatFunction: formatDate
            
        }))
        listColumns.push(Datatable_Column({
            name:"Profile Updated Date", 
            columnName:"updateDate", 
            selectedRows: selectedList, 
            sortable:true, 
            sortFieldNum:4,
            sortingInfo:sortingInfo,
            formatFunction: formatDate
        }))

        return listColumns;
      }

      const tableTitle = function () {
        return "Profile Activity";
      }
      
      const tableDescription = function() {
        return "The Profile Activity table displays PSO Profile Submission Activity.";
      }
      const [selectedCount, setSelectedCount] = useState(0);


    const handleManagePSOProfile = () => {
        
        navigate(
            "/manage/profile",
            { state: {
                backRedirect: {
                    path: location.pathname,
                    state: location.state
                }
            }}
           
        );
    }

  return (
    <>
       
        { filter!=null ?
            <DatatableBase 

                tableClassName="profileActivityTable" 
                uniqueId="profileActivityTable"
                getData={getTest} 
                dataPath={"pageResp"}
                
                filter = {filter}
                setFilter={setFilter}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={"Search by Reporting Year or Profile Status."} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
            >
                    {
                        <Col className="d-flex justify-content-end ">
                        {
                           <TextButton className="ms-auto " onClick={handleManagePSOProfile} variant="normal" content={"Manage PSO Profile"}/>
                        }
                        
                        </Col>
                    }
               
            
            </DatatableBase>
            :null
        }  
    </>
  );
}

export default ProfileActivityTable;